import _ from "lodash";
import axios from "axios";
import math from "mathjs";
import { createSelector } from "reselect";

import buildFetchDuck from "../../vendor/signal-utils/build-fetch-duck";
import chainReducers from "../../vendor/signal-utils/chain-reducers";
import apiUrl from "../../api-url";
import { alfBy } from "../../components/selectors";

export const INITIAL_RADIUS_M = math.unit(1, "mile").to("m").value;

// URL parameter for adding locations
export const ADD_LOCATION_ID = "add";

// URLs
const LOCATIONS_URL = apiUrl("/location/locations");

const locationsDuck = buildFetchDuck("locations");
const SET_SEARCH_STR = "locations/SET_SEARCH_STR";

export function fetchLocations() {
  return dispatch => dispatch(locationsDuck.fetch(LOCATIONS_URL));
}

export function addLocation(data) {
  const payload = { ...data, organization_lad_id: data.lad.id };
  return dispatch => {
    return Promise.all([axios.post(`${LOCATIONS_URL}`, payload)])
      .then(responses => {
        dispatch(fetchLocations());
      })
      .catch(err => {
        throw new Error(err);
      });
  };
}

export function editLocation(id, data) {
  const payload = { ...data, organization_lad_id: data.lad.id };
  return dispatch => {
    return Promise.all([axios.put(`${LOCATIONS_URL}/${id}`, payload)])
      .then(responses => {
        dispatch(fetchLocations());
      })
      .catch(err => {
        throw new Error(err);
      });
  };
}

export function deleteLocation(id) {
  return dispatch => {
    return Promise.all([axios.delete(`${LOCATIONS_URL}/${id}`)])
      .then(responses => {
        dispatch(fetchLocations());
      })
      .catch(err => {
        throw new Error(err);
      });
  };
}

export function setSearchStr(str) {
  return {
    type: SET_SEARCH_STR,
    searchStr: str
  };
}

// selectors

export const getLocations = state => _.get(state, "locations.data", []);
export const selectLocationsAlphabetically = alfBy(getLocations, 'name');

export const selectLocationsById = createSelector([getLocations], locations =>
  _.keyBy(locations, "id")
);

export const getSelectedLocationId = state =>
  _.get(state, "location.payload.location_id");

export const selectSelectedLocation = createSelector(
  [getSelectedLocationId, selectLocationsById],
  (locationId, locationsById) => locationsById[locationId]
);

export function getDefaultLocation() {
  return {
    name: "",
    country: "",
    state: "",
    city: "",
    address: "",
    postal_code: "",
    codes: [],
    geofence: {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: []
      },
      properties: {
        buffer: INITIAL_RADIUS_M,
        center: {
          latitude: null,
          longitude: null
        }
      },
      lad: {}
    }
  };
}

// initial state

const initialState = {
  data: [getDefaultLocation()],
  searchStr: ""
};

// reducer
function LocationsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SEARCH_STR:
      return { ...state, searchStr: action.searchStr };
    default:
      return state;
  }
}

export default chainReducers([LocationsReducer, locationsDuck.reducer]);



// WEBPACK FOOTER //
// ./src/modules/locations/LocationsState.js